import { Draggable } from "@hello-pangea/dnd";
import { Divider, Typography, Paper, Box, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useModal } from "../../../../../../hooks/useModal";
import EditTaskForm from "../../../../../../components/forms/tasks/EditTaskForm";
import { useConfirmDialog } from "../../../../../../hooks/useConfirmDialog";
import LoadingAnimation from "../../../../../../components/_common/Loading";
import tasksController from "../../../../../../Api/tasksController";
import { useToast } from "../../../../../../hooks/useToast";


const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

const TaskItem = ({ item, idx, onRefreshTasks }) => {
    const toast = React.useRef(useToast()).current;
    const [loading, setLoading] = React.useState(false);
    const { confirm, dialog } = useConfirmDialog();
    const modal = useModal();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleDeleteTask = async () => {
        const response = await confirm('Usunąć zadanie?')
        if (!response) return;
        setLoading(true);
        const res = await tasksController.deleteTask(item._id);
        setLoading(false);
        if (!res.ok) return toast.error(res.message)
        onRefreshTasks();
        toast.success(res.message)
    }


    if (loading) return <LoadingAnimation />


    return (
        <>
            <Draggable key={item._id} draggableId={item._id} index={idx}>
                {(provided, snapshot) => (
                    <Paper
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        elevation={2}
                        sx={{
                            width: "100%",
                            minHeight: 80,
                            mb: 2,
                            p: 2,
                            borderRadius: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            opacity: snapshot.isDragging ? 0.7 : 1,
                            background: "#fff",
                            transition: "opacity 0.2s",
                            cursor: "grab",
                            userSelect: "none",
                        }}
                    >
                        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", mb: 1 }}>
                            <Typography
                                variant="subtitle1"
                                fontWeight={700}
                                sx={{
                                    width: "100%",
                                    mb: 0.5,
                                    color: "#1976d2",
                                    textAlign: "left",
                                    wordBreak: "break-word",
                                }}
                            >
                                {item.name}
                            </Typography>
                            <IconButton
                                id="demo-customized-button"
                                aria-controls={open ? 'demo-customized-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                            >
                                <MoreHorizIcon />
                            </IconButton>
                            <StyledMenu
                                id="demo-customized-menu"
                                slotProps={{
                                    list: {
                                        'aria-labelledby': 'demo-customized-button',
                                    },
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={() => (modal.open(
                                    <EditTaskForm
                                        taskTitle={item.name}
                                        taskDescription={item.description}
                                        taskId={item._id}
                                        onRefreshTasks={onRefreshTasks}
                                    />
                                ))} disableRipple>
                                    <EditIcon />
                                    Edytuj
                                </MenuItem>
                                <MenuItem onClick={handleDeleteTask} disableRipple>
                                    <DeleteIcon />
                                    Usuń
                                </MenuItem>
                            </StyledMenu>
                        </Box>
                        <Divider sx={{ width: "100%", mb: 1 }} />
                        <Typography
                            variant="body2"
                            sx={{
                                whiteSpace: "pre-line",
                                color: "#333",
                                wordBreak: "break-word",
                                fontSize: 15,
                                lineHeight: 1.5,
                                width: "100%",
                                textAlign: "left",
                            }}
                        >
                            {item.description}
                        </Typography>
                    </Paper>
                )}
            </Draggable>
            {dialog}
        </>
    );
};

export default TaskItem;